import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.259 3.5a7.758 7.758 0 1 0-.001 15.516 7.758 7.758 0 0 0 0-15.516ZM1.5 11.257a8.758 8.758 0 1 1 15.881 5.096l1.068.797.45-.603a.5.5 0 0 1 .7-.102l2.585 1.928c.645.48.781 1.399.3 2.045l-.357.477c-.48.646-1.4.78-2.045.298l-2.586-1.928a.5.5 0 0 1-.102-.7l.458-.614-1.099-.819A8.758 8.758 0 0 1 1.5 11.257Zm8.791-4.264a2.428 2.428 0 1 0 0 4.855 2.428 2.428 0 0 0 0-4.855ZM6.863 9.42a3.428 3.428 0 1 1 6.856-.001 3.428 3.428 0 0 1-6.856 0ZM8.13 14.64c-.843 0-1.427.732-1.427 1.426a.5.5 0 0 1-1 0c0-1.17.958-2.426 2.427-2.426h4.321c1.53 0 2.427 1.272 2.427 2.426a.5.5 0 0 1-1 0c0-.699-.542-1.426-1.427-1.426H8.13Zm11.272 2.905-.908 1.217 2.186 1.63a.464.464 0 0 0 .646-.094l.356-.478a.464.464 0 0 0-.096-.645l-2.184-1.63Z",
      fill: "#17191C"
    }, null, -1)
  ])))
}
export default { render };